<script setup lang="ts">
const _props = defineProps<{
  theme: string | null | undefined
  data: {
    media?: unknown
    title?: string
    subTitle?: string
    text?: unknown
    tags?: unknown
    person?: unknown
    callToActions?: unknown
    layout?: boolean
  }
}>()

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})
provide('showMediaCaption', true)
</script>

<template>
  <div class="mx-bleed relative grid border-t border-(--theme-fg)/15 text-(--theme-fg)">
    <h2 class="my-8 block text-sm font-bold uppercase">{{ data.title }}</h2>
    <div
      class="relative flex h-full w-full flex-col gap-10 lg:flex-row lg:gap-(--grid-gap)"
      :class="{ 'lg:flex-row-reverse': data?.layout }"
    >
      <div
        class="content lg:w-cols-6 flex w-full shrink-0 flex-col justify-between gap-10 lg:gap-45 lg:pt-15"
      >
        <div class="lg:w-cols-5 flex h-full flex-col justify-between gap-10 lg:gap-15">
          <div class="flex flex-col gap-10 lg:gap-15">
            <h2 v-if="data?.subTitle" class="font-display text-lg lg:text-xl">
              {{ data.subTitle }}
            </h2>
            <CommonMedia
              v-if="isMobile"
              class="aspect-square h-full w-full overflow-clip rounded-sm object-cover"
              :media="data?.media"
              :aspect-desktop="7 / 6"
              :sizes="'xs:90vw sm:90vw md:90vw lg:50vw xl:50vw xxl:50vw'"
            />
            <div class="rich-text lg:w-cols-5 w-full">
              <ElementsPortableTextWrapper v-if="data?.text" :content="data?.text" />
            </div>
            <div
              v-if="data?.callToActions?.length > 0"
              class="ctas lg:w-cols-5 flex w-full flex-col items-start gap-2.5"
            >
              <ElementsButton
                v-for="(cta, index) in data?.callToActions"
                :key="index"
                :link="cta"
              />
            </div>
            <CardsPerson v-if="data.person" :person="data.person" :inline="true" />
          </div>
        </div>
      </div>
      <div
        v-if="!isMobile"
        class="media lg:w-cols-5 aspect-square h-auto w-full shrink-0 overflow-clip rounded-sm lg:sticky lg:top-18 lg:aspect-[6/7]"
        :class="{ 'mr-auto': data?.layout }"
      >
        <CommonMedia
          class="aspect-square h-full w-full object-cover"
          :media="data?.media"
          :aspect-desktop="7 / 6"
          :sizes="'xs:40vw sm:40vw md:40vw lg:50vw xl:50vw xxl:50vw'"
        />
      </div>
    </div>
  </div>
</template>
